<template>
    <div>
        <b-button :href="$api_url+'/investment/template'" ><b-icon icon="code-slash" ></b-icon> Download Template</b-button>

        <b-overlay :show="showoverlay" rounded="sm" class="mt-4">
            <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
            <br />
            
            <div v-if='errormsg'>
                <div v-if="Object.keys(errormsg).length > 0" class="alert alert-danger my-3">Total error {{Object.keys(errormsg).length}}</div>
                                
                <div class="accordion" role="tablist" >
                                        
                    <b-card no-body class="mb-1"  v-for='(error,i) in errormsg' :key="i">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-button v-b-toggle="i" variant="info">Error on row {{i}}</b-button>
                        </b-card-header>
                        <b-collapse v-bind:id=i accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                            <b-card-text>{{ error }}</b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>



                </div>
            </div>
        </b-overlay>
  </div>
</template>
<script>

    export default{
        
        mounted() {
        },
        data(){            
            
            return {
                ce : true,
                empfile : null,
                has_file : false,
                errormsg : [],
                showoverlay : false,
                blankmsg : 'Fetching data..',

                
                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                employees : [],                
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},

                search:  '',
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                
            }
        },
        methods:{
                        
            uploadFile:function(event) 
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                this.show_employee_list = false;
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.$api_url+'/investment/import', data , config).
                    then(function (response){

                    this.showoverlay = false;    
                         
                        this.$bvToast.toast('Processing the data feed file.', {
                                            title: `Job on progress`,
                                            variant: 'info',
                                            solid: true
                                        });                        
                    
                        
                    }.bind(this)).
                    catch(function (error) 
                            {
                                //alert(error.response.data.errors);
                            });
            },
            
        },
        created: function(){
            
            //Fire.$on('reloadUsers', () => {this.processFileData()})
        },
    }
</script>